import { useQuery } from "@tanstack/react-query";

import { ENDPOINTS } from "@/api/application-api";
import { handleResponse } from "@/utils/errorResponseHandlers";
import { jsonAuthHeaders } from "@/utils/headers";

export interface ModelMetadataEntry {
  name: string | null;
  description: string | null;
  context_length: number | null;
  price_per_1m_tokens_input: number | null;
  price_per_1m_tokens_output: number | null;
  input_modalities: string[];
  output_modalities: string[];
  supported_parameters: string[];
  max_completion_tokens: number | null;
  knowledge_cutoff: string | null;
  latency: string | null;
  deprecation_date: string | null;
  retirement_date: string | null;
}

export interface ModelMetadataResponse {
  success: boolean;
  models: Record<string, ModelMetadataEntry>;
  provider_map: Record<string, string>;
}

const EMPTY_RESPONSE: ModelMetadataResponse = {
  success: true,
  models: {},
  provider_map: {},
};

export const useModelMetadata = (userToken: string) =>
  useQuery<ModelMetadataResponse>({
    queryKey: ["globalModelMetadata"],
    queryFn: async () => {
      const response = await fetch(ENDPOINTS.global_model_metadata, {
        headers: jsonAuthHeaders(userToken),
        method: "GET",
      });
      if (!response.ok) {
        return EMPTY_RESPONSE;
      }
      return handleResponse(response);
    },
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    retry: false,
  });
